// extracted by mini-css-extract-plugin
module.exports = {"spanGrey":"UIconstants_spanGrey__3z3K7"};